<template>
    <div>
        <div v-for="(api_url,key) in api_urls" :key="key">
            <el-input v-model="api_url[0]" placeholder="FLAG" class="flag" v-on:blur="setUrl" />
            <el-input v-model="api_url[1]" placeholder="http://api.offer.com/bulk..." class="url" v-on:blur="setUrl" />
            <el-button type="danger" @click="delUrl(key)">DEL</el-button>
        </div>
        <el-button type="success" @click="addUrl">Append API URL</el-button>
    </div>
</template>

<script>
export default {
	data() {
		return{
            api_urls:[],
            is_first:true
		}
	},
    props:['value'],
    watch: {
        value:function(urls_json) {
            if(this.is_first) {
                // console.log(urls);
                this.is_first = false;
                const urls_obj = JSON.parse(urls_json);
                for(const flag in urls_obj) {
                    this.api_urls.push([flag,urls_obj[flag]]);
                }
                // console.log(this.api_urls);
            }
        }
    },
    methods: {
        addUrl: function() {
            this.api_urls.push(['','']);
        },
        delUrl: function(key) {
            this.api_urls.splice(key,1);
            this.setUrl();
        },
        setUrl: function() {
            // console.log(this.api_urls);
            let url_obj = new Object;
            for(const k in this.api_urls) {
                if(this.api_urls[k][0] != '') {
                    this.api_urls[k][1] = this.api_urls[k][1].replace(/^\s|\s$/g, '');
                    url_obj[this.api_urls[k][0]] = this.api_urls[k][1];
                }
            }
            // console.log(url_obj);
            this.$emit('input',JSON.stringify(url_obj));
        }
    }
}
</script>

<style scoped>
.flag {
    width:13%;
}
.url {
    width:76%;
}
</style>

